
import routes from "@/routes";
import { lazy } from "react";
const LineItem = lazy(() => import("@/modules/LineItem"));
const ListLineItem = lazy(() => import("@/modules/LineItem/ListLineItem"));
const CreateOrEditDisplayLineItem = lazy(() => import("@/modules/LineItem/CreateOrEdit/Display"));

const CampaignRoutes = {
  element: <LineItem />,
  path: routes.CAMPAIGNS.GENERAL_CAMPAIGN.LINE_ITEMS.INDEX(),
  children: [
    { element: <ListLineItem />, path: "" },
    {
      element: <CreateOrEditDisplayLineItem />,
      path: `${routes.CAMPAIGNS.GENERAL_CAMPAIGN.LINE_ITEMS.DISPLAY.INDEX}/${routes.CAMPAIGNS.GENERAL_CAMPAIGN.LINE_ITEMS.DISPLAY.CREATE}`,
    },
    {
      element: <CreateOrEditDisplayLineItem isEdit />,
      path: `${routes.CAMPAIGNS.GENERAL_CAMPAIGN.LINE_ITEMS.DISPLAY.INDEX}/${routes.CAMPAIGNS.GENERAL_CAMPAIGN.LINE_ITEMS.DISPLAY.EDIT()}`,
    },
  ],
};

export default CampaignRoutes;
